import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { VideoPlayerComponentBase } from "front-end/components/video-box/factories/video-player.component.base";
import * as Vimeo from "vimeo__player";

export class VimeoPlayerComponent extends VideoPlayerComponentBase implements IVideoPlayerComponent {
    private _internalPlayer: Vimeo.Player = null;

    public play(): void {
        void this._internalPlayer.play();
    }

    public pause(): void {
        void this._internalPlayer.pause();
    }

    public loop(state: boolean): void {
        void this._internalPlayer.setLoop(state);
    }

    public mute(): void {
        void this._internalPlayer.setVolume(0);
    }

    public destroy(): void {
        void this._internalPlayer.destroy();
    }

    private bindEvents(): void {
        this._internalPlayer.on("play", () => this.setState(true));
        this._internalPlayer.on("pause", () => this.setState(false));
    }

    public init(internalPlayer: Vimeo.Player): void {
        this._internalPlayer = internalPlayer;
        this.bindEvents();
    }

    private setState(isPlaying: boolean): void {
        this._isPlaying.next(isPlaying);
    }
}
